import { Suspense, } from "react";
import PropTypes from "prop-types";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";

/** Components */
import Login from "../pages/auth/Login";
import Layouts from "../layouts/Layouts";
import ProtectedRoute from "./ProtectedRoute";
import NotFound from "../pages/notFound/NotFound";

const AppRoutes = (props) => {

    return (
        <Router>
            <Suspense fallback={<div><div>Loading...</div> </div>}>
                <Routes>

                    <Route name="Layout" path="/"
                        element={
                            <ProtectedRoute>
                                <Layouts componentRoutes={props.componentRoutes} />
                            </ProtectedRoute>}>
                        {props.componentRoutes
                            .map((route) => (
                                <Route
                                    key={route.path}
                                    path={route.path}
                                    element={<route.component securityKey={route.securityKey} />}
                                />
                            ))}
                    </Route>

                    <Route path="/login" name="Login" element={<Login />} />
                    <Route path="*" name="Not Found" element={<NotFound />} />
                </Routes>
            </Suspense>
        </Router>
    );
}

AppRoutes.propTypes = {
    componentRoutes: PropTypes.arrayOf(
        PropTypes.shape({
            path: PropTypes.string.isRequired,
            component: PropTypes.elementType.isRequired,
            securityKey: PropTypes.string,
        })
    ).isRequired,
};

export default AppRoutes;